import React from "react";
import { formatFileSize, getFileTypeIcon, getTotalFileSize } from "./utils";
import { FileUploadConfig } from "./types";

interface FileListProps {
  files: FileList;
  isUploading: boolean;
  config: FileUploadConfig;
  onRemoveFile: (index: number) => void;
}

export const FileList: React.FC<FileListProps> = ({
  files,
  isUploading,
  config,
  onRemoveFile
}) => {
  return (
    <div style={{ marginBottom: "20px" }}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "15px"
        }}
      >
        <h4 style={{ margin: 0 }}>선택된 파일들 ({files.length}개)</h4>
        <div style={{ fontSize: "14px", color: "#666" }}>
          총 크기: {getTotalFileSize(files)} /{" "}
          {formatFileSize(config.maxTotalSize)}
        </div>
      </div>

      <div
        style={{
          maxHeight: "300px",
          overflowY: "auto",
          border: "1px solid #e0e0e0",
          borderRadius: "6px"
        }}
      >
        {Array.from(files).map((file: File, index: number) => (
          <div
            key={index}
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "12px 15px",
              backgroundColor: index % 2 === 0 ? "#f8f9fa" : "#ffffff",
              borderBottom:
                index < files.length - 1 ? "1px solid #e0e0e0" : "none"
            }}
          >
            <div style={{ display: "flex", alignItems: "center", flex: 1 }}>
              <span style={{ marginRight: "10px", fontSize: "20px" }}>
                {getFileTypeIcon(file.type)}
              </span>
              <div>
                <div style={{ fontWeight: "500", marginBottom: "2px" }}>
                  {file.name}
                </div>
                <div style={{ fontSize: "12px", color: "#666" }}>
                  {formatFileSize(file.size)} • {file.type || "알 수 없는 형식"}
                </div>
              </div>
            </div>

            <button
              onClick={() => onRemoveFile(index)}
              disabled={isUploading}
              style={{
                background: "none",
                border: "none",
                color: "#dc3545",
                cursor: isUploading ? "not-allowed" : "pointer",
                fontSize: "18px",
                padding: "5px",
                borderRadius: "3px"
              }}
              title="파일 제거"
            >
              ✕
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};
